import React from "react";
import PropTypes from "prop-types";
import { Puff } from "./components/Puff";
import { FlexContainer } from "BaseComponents/Flex";
import { useGlobal } from "reactn";
import { PageTransition } from "Animations";
import { BlockContainer } from "BaseComponents/Wrappers";

export const StartPagePuffs = ({ model, margin }) => {
	const [theme] = useGlobal("theme");
	return (
		<PageTransition transitionDuration="500" delay="400">
			<BlockContainer>
				<FlexContainer
					smallrow={true}
					column={false}
					width="auto"
					smallwidth="auto"
					margin={margin ? margin : "0"}
					smallmargin="0 -5px"
					maxwidth={theme.grid.outer}
					flexwrap="wrap"
					gap={"15px"}
					justifyContentSmall={'center'}
				>
					{model.map((puff, i) => {
						return <Puff {...puff} key={i} />;
					})}
				</FlexContainer>
			</BlockContainer>
		</PageTransition>
	);
};

StartPagePuffs.propTypes = {
	model: PropTypes.array,
};
